import Box from "@mui/material/Box";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import IncidentsPage from "./ui";

const Incidents = () => {
  return (
    <DashboardLayout>
      <Box sx={{ flexShrink: 0 }}>
        <DashboardNavbar />
      </Box>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <IncidentsPage />
      </Box>
    </DashboardLayout>
  );
};

export default Incidents;
